<template>
  <span @click="fetchCashoutPrice" v-if="d">
    <span v-tooltip="d.tickettimeOdd +' / '+ d.currentOdd">{{ d.cashout | toMoney }}</span> <span v-if="d1"  v-tooltip="d1.tickettimeOdd +' / '+ d1.currentOdd">({{ d1.cashout | toMoney }})</span>
  </span>
</template>

<script>
export default {
  name: 'cashoutPrice',
  props: ['id'],
  data () {
    return {
      d: null,
      d1: null,
      timer: null
    }
  },
  watch: {
    id () {
      this.fetchCashoutPrice()
      this.fetchCashoutPriceFutureRelease()
    }
  },
  mounted() {
    this.fetchCashoutPrice()
    this.fetchCashoutPriceFutureRelease()
    this.timer = setInterval(this.fetchCashoutPrice, 10000)
    this.timer2 = setInterval(this.fetchCashoutPriceFutureRelease, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.timer2)
  },
  methods: {
    async fetchCashoutPrice () {
      this.d = null
      this.$http.get(bsapi+'api/v1/cashout-preview/'+this.id)
        .then(response => {
          this.d = response.body
        }, response => {})
    },
async fetchCashoutPriceFutureRelease () {
  this.d1 = null
  try {
    const response = await fetch(`https://ftapi.exquo.net/api/v1/cashout-preview/${this.id}`)
    if (!response.ok) throw new Error(`HTTP ${response.status}`)
    this.d1 = await response.json()
  } catch (e) {
    console.error('cashout preview failed:', e)
  }
},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/cashoutPrice.vue